// File: Footer.js
//
// The strip of text at the bottom of every page (copyright + credit).
// Used by App.js once — so editing the text here changes it everywhere.
//
// To change what the footer says, just edit the text between the JSX
// tags below. To change colors, edit the inline `style` values.

import React from "react";

export default function Footer() {
  return (
    <footer
      className="w-full text-center text-xs font-bold py-2 px-4 tracking-wide"
      style={{
        color: "#0A0A0A",
        textShadow: "0 1px 2px rgba(255,255,255,0.6)",
      }}
    >
      Copyright &copy;2003 - 2026{" "}
      <span style={{ color: "#1F3800" }}>Increasing H.O.P.E</span>{" "}
      - Financial Training Center &middot; Built by{" "}
      <span style={{ color: "#003840" }}>HDev</span>
    </footer>
  );
}
